import React,{useState, useEffect} from 'react';
import PropTypes from 'prop-types';


export default function MessageModal(param) {

    const [message, setMessage] = useState("");

    useEffect(() => {
        if(param.data !== undefined) {
            setMessage(param.data);
        }
    }, [param.data])

    function messageChange(e) {
        setMessage(e.target.value);
    }

    function messageSave() {
        param.callbackMessage(message);
        setMessage('');
        
    }

    function modalClose() {
        setMessage("");
    }
    

    return(
        <div className="modal fade" id="messageModal" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog   modal-dialog-centered">
                <div className="modal-content">
                
                    <div className="modal-header">
                        <h4 className="modal-title">메시지 등록</h4>
                        <button type="button" className="close" data-dismiss="modal" onClick={modalClose}>&times;</button>
                    </div>
                    
                    <div className="modal-body">
                        <textarea className="form-control" rows="3" placeholder="메시지" onChange={messageChange} value={message}/>
                    </div>
                    
                    <div className="modal-footer">
                        <button type="button"  className="btn btn-secondary" data-dismiss="modal" onClick={modalClose}>닫기</button>
                        <button type="button" className="btn btn-primary" onClick={messageSave} data-dismiss="modal"><i className="fas fa-edit"></i> 저장하기</button>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}

MessageModal.propTypes = {
    data: PropTypes.any,
    callbackMessage: PropTypes.any
  };